<!-- 商户-站点管理 -->
<template>
  <div class="user_service-page" v-cloak>
    <van-nav-bar :border="false" left-arrow fixed title="商户-站点管理" class="user_work_order_nav_bar" @click-left="onClickLeft" :z-index="20" :style="'background: #2998FF; color:#FFFFFF;'"></van-nav-bar>

    <!-- 列表 -->
    <div class="list">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getList">
        <div class="item" v-for="(item, index) in list" :key="index">

          <!-- 内容 -->
          <div class="center-block">
            <p class="tips"><span>站点名称:{{item.station_name}}</span>
              <span v-if="item.status == 1" class="yy">{{item.status_name}}</span>
              <span v-if="item.status == 2" class="wy">{{item.status_name}}</span>
            </p>
            <p class="name">洗车机数：{{item.machine_count}}台</p>
            <p class="text">站点地址：{{item.addr}}{{item.address}}</p>
          </div>

        </div>
      </van-list>
    </div>

    <!-- <div class="list" v-else>
       <van-divider>没有更多了~</van-divider>
     </div> -->

    <van-empty class="custom-image" v-if="list.length < 1" />
  </div>
</template>

<script type="text/babel">
export default {
  name: "sys-station-list",
  components: {},
  props: {},
  data() {
    return {
      list: [
        // {
        //   id: "站点id",
        //   station_name: "站点名称",
        //   machine_count: "设备数量",
        //   status: "状态id  1=营业 2=未营业",
        //   addr: "区域",
        //   address: "位置",
        //   status_name: "状态名称",
        // },
      ],
      pageNum: 1,
      pageSize: 10,
      loading: false,
      finished: false,
    };
  },
  watch: {},
  created() {},
  mounted() {},
  methods: {
    getList() {
      this.$toast.loading();
      let _this = this;
      let data = {
        page: _this.pageNum,
        limit: _this.pageSize,
      };
      _this.$post("/api/m_station_list", data, data).then((res) => {
        // console.log(res.data);
        this.$toast.clear();
        _this.loading = false; // 加载状态结束

        if (res.data.code == 0) {
          // console.log(res.data.data);
          let lists = res.data.data;

          if (lists && lists.length > 0) {
            if (_this.pageNum == 1) {
              _this.list = [];
              _this.list = lists;
            } else {
              _this.list = _this.list.concat(lists);
            }
            _this.pageNum++;
            if (lists.length < _this.pageSize) {
              _this.finished = true; // 数据全部加载完成
            }
          } else {
            console.log("444");
            _this.finished = true; // 数据全部加载完成
          }
        } else {
          console.log("555");
          _this.$toast.fail(res.data.message);
          _this.finished = true;
        }
      });
    },
    // 返回上一页
    onClickLeft() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss">
.user_service-page {
  // 空状态
  .custom-image .van-empty__image {
    width: 260px;
    height: 300px;
  }
}
.user_work_order_nav_bar {
  .van-nav-bar__content {
    .van-icon,
    .van-nav-bar__title {
      color: #fff;
    }
  }
}
</style>


<style lang="scss" scoped>
.user_service-page {
  height: 100%;
  width: 100%;
  padding: 50px 0;
  background-color: #f7f7f7;
  overflow-x: scroll;
  -webkit-overflow-scrolling: touch;
  .list {
    padding: 0 10px;
  }
  .yy {
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #3573f8;
  }
  .wy {
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #f98d23;
  }
  .item {
    margin: 15px 0;
    background-color: #fff;
    box-shadow: 0px 2px 5px rgba(69, 79, 99, 0.06);
    // overflow: hidden;
    border-radius: 5px;
    // 内容模块
    .center-block {
      width: 100%;
      height: 100%;
      // background-color: #eee;
      display: flex;
      flex-direction: column;
      justify-content: center;

      padding: 15px;

      .tips {
        font-size: 15px;

        display: flex;
        justify-content: space-between;
        align-items: center;
        font-family: Source Han Sans CN;
        color: #333333;
        font-weight: bold;
        margin-bottom: 10px;
      }
      .name {
        font-size: 12px;

        font-family: Source Han Sans CN;
        margin-bottom: 10px;
        font-weight: 500;
        // line-height: 26px;
        color: #cccccc;
        text-align: left;
        // display: -webkit-box; /*作为弹性伸缩盒子模型显示*/
        // -webkit-line-clamp: 1; /*显示的行数；如果要设置2行加...则设置为2*/
        // overflow: hidden; /*超出的文本隐藏*/
        // text-overflow: ellipsis; /* 溢出用省略号*/
        // -webkit-box-orient: vertical; /*伸缩盒子的子元素排列：从上到下*/
      }
      .text {
        text-align: left;
        font-size: 12px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        line-height: 17px;
        color: #cccccc;
        // display: -webkit-box; /*作为弹性伸缩盒子模型显示*/
        // -webkit-line-clamp: 3; /*显示的行数；如果要设置2行加...则设置为2*/
        // overflow: hidden; /*超出的文本隐藏*/
        // text-overflow: ellipsis; /* 溢出用省略号*/
        // -webkit-box-orient: vertical; /*伸缩盒子的子元素排列：从上到下*/
      }
    }
  }
}
.click:active {
  transform: scale(0.95);
  -webkit-transform: scale(0.95);
  -moz-transform: scale(0.95);
}
</style>
